var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup39(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.742,
    height: 18.236,
    viewBox: "0 0 15.742 18.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(2 0)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M7.47,2.4a2,2,0,0,1,3.3,0l5.316,7.732a2,2,0,0,1-1.648,3.133H3.8a2,2,0,0,1-1.648-3.133Z",
    transform: "translate(0.48 18.236) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y2: 13.64,
    transform: "translate(0 2.423)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup39);
export default __webpack_public_path__ + "static/media/Group 39.9f4b06e0f97b35f93b6f9b1ae57948ff.svg";
export { ForwardRef as ReactComponent };